export const GrammarCheckerTemplate = Object.freeze({
  FunnowProductContent: 'funnow_product_content',
  FunbookProductContent: 'funbook_product_content',
  PreDepartureConsiderations: 'pre_departure_considerations',
  Considerations: 'considerations',
  FunnowProductIntro: 'funnow_product_introduction',
  FunbookProductIntro: 'funbook_product_introduction',
  FunnowPurchaseNotice: 'funnow_purchase_notice',
  FunbookPurchaseNotice: 'funbook_purchase_notice',
  FunnowSupplementaryRules: 'funnow_supplementary_rules',
  FunbookSupplementaryRules: 'funbook_supplementary_rules',
  BranchSeoContent: 'branch_seo_content',
  BranchIntro: 'branch_intro',
  BranchName: 'branch_name',
  BranchLocationDescription: 'branch_location_description',
  BranchNeedToKnow: 'branch_need_to_know',
  ProductName: 'product_name',
  ProductDurationDescription: 'product_duration_description',
  ProductMemberReward: 'product_member_reward'
})

export const AItranslationTemplate = Object.freeze({
  Default: 'default',
  BranchOpeningHours: 'branch_opening_hours'
})
